interface Favicon {
	rel: string
	href: string
	sizes?: string
	type?: string
}

export const useFavicons = (): any[] => {

	const appleIconSizes: number[] = [57,60,72,76,114,120,144,152,180]
	const androidIconSizes: number[] = [192]
	const faviconSizes: number[] = [16,32,96]
	const config = useRuntimeConfig()

	const appleIcons = appleIconSizes.map((size): Favicon => {
		return {
			rel: 'apple-touch-icon',
			sizes: `${size}x${size}`,
			href: `${config.app.cdnURL}/favicons/apple-icon-${size}x${size}.png`
		}
	})

	const androidIcons = androidIconSizes.map((size): Favicon => {
		return {
			rel: 'icon',
			sizes: `${size}x${size}`,
			type: 'image/png',
			href: `${config.app.cdnURL}/favicons/android-icon-${size}x${size}.png`
		}
	})

	const favicons = faviconSizes.map((size): Favicon => {
		return {
			rel: 'icon',
			sizes: `${size}x${size}`,
			type: 'image/png',
			href: `${config.app.cdnURL}/favicons/favicon-${size}x${size}.png`,
		}
	})

	return [
		{
			rel: 'shortcut icon',
			href: `${config.app.cdnURL}/favicons/favicon.ico`,
		},

		...appleIcons,
		...favicons,
		...androidIcons
	]
}